// Customer Management Help Content (HTML)
export const customerHelpContent = `
<h1>คู่มือการจัดการลูกค้า (Customer Management)</h1>

<h2>ภาพรวม</h2>
<p>ระบบจัดการลูกค้าช่วยให้คุณสามารถสร้าง จัดการ และติดตามข้อมูลลูกค้าได้อย่างครบถ้วน โดยรองรับลูกค้าประเภทต่างๆ และการเชื่อมโยงข้อมูลที่ซับซ้อน</p>

<h2>ประเภทลูกค้า (Customer Types)</h2>

<h3>1. บุคคล (Person)</h3>
<p>สำหรับลูกค้าที่เป็นบุคคลทั่วไป ต้องระบุข้อมูล:</p>
<ul>
  <li><strong>ชื่อ-นามสกุล</strong> (FirstName, LastName) - จำเป็น</li>
  <li><strong>อีเมล</strong> (PersonEmail)</li>
  <li><strong>เบอร์โทรศัพท์</strong> (PersonPhone)</li>
  <li><strong>ตำแหน่ง</strong> (PersonTitle)</li>
</ul>

<h3>2. บริษัท (Company)</h3>
<p>สำหรับลูกค้าที่เป็นบริษัทหรือองค์กร ต้องระบุข้อมูล:</p>
<ul>
  <li><strong>ชื่อบริษัท</strong> (CompanyName) - จำเป็น</li>
  <li><strong>เบอร์โทรศัพท์บริษัท</strong> (CompanyPhone)</li>
  <li><strong>ที่อยู่บริษัท</strong> (CompanyAddress)</li>
  <li><strong>อุตสาหกรรม</strong> (Industry)</li>
</ul>

<h3>3. บุคคล+บริษัท (Individual+Company)</h3>
<p>สำหรับกรณีที่ลูกค้าเป็นบุคคลที่ทำงานในบริษัท โดยต้องการเก็บข้อมูลทั้งบุคคลและบริษัท:</p>
<ul>
  <li>ต้องระบุข้อมูลทั้งส่วนบุคคล (ชื่อ-นามสกุล) และบริษัท (ชื่อบริษัท)</li>
  <li>ระบบจะสร้างข้อมูลทั้ง Person และ Company พร้อมเชื่อมโยงกัน</li>
</ul>

<h2>ฟิลด์สำคัญ</h2>

<h3>ฟิลด์พื้นฐาน</h3>
<table>
  <thead>
    <tr>
      <th>ฟิลด์</th>
      <th>คำอธิบาย</th>
      <th>จำเป็น</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><strong>Customer Code</strong></td>
      <td>รหัสลูกค้าที่ใช้ระบุตัวตนในระบบ</td>
      <td>✅ (สร้างอัตโนมัติได้)</td>
    </tr>
    <tr>
      <td><strong>Customer Type</strong></td>
      <td>ประเภทลูกค้า (Person, Company, Individual+Company)</td>
      <td>✅</td>
    </tr>
    <tr>
      <td><strong>FirstName / LastName</strong></td>
      <td>ชื่อและนามสกุล (จำเป็นสำหรับ Person)</td>
      <td>✅ (Person)</td>
    </tr>
    <tr>
      <td><strong>CompanyName</strong></td>
      <td>ชื่อบริษัท (จำเป็นสำหรับ Company)</td>
      <td>✅ (Company)</td>
    </tr>
    <tr>
      <td><strong>PersonEmail</strong></td>
      <td>อีเมลส่วนบุคคล (สามารถระบุหลายค่าได้ คั่นด้วย ;)</td>
      <td>❌</td>
    </tr>
    <tr>
      <td><strong>PersonPhone</strong></td>
      <td>เบอร์โทรศัพท์ส่วนบุคคล (สามารถระบุหลายค่าได้ คั่นด้วย ;)</td>
      <td>❌</td>
    </tr>
  </tbody>
</table>

<h3>ฟิลด์เพิ่มเติม</h3>
<ul>
  <li><strong>Status</strong>: สถานะลูกค้า (Active, Inactive, Prospect, etc.)</li>
  <li><strong>Priority</strong>: ลำดับความสำคัญ</li>
  <li><strong>Salesperson</strong>: พนักงานขายที่ดูแลลูกค้า</li>
  <li><strong>Source</strong>: แหล่งที่มาของลูกค้า</li>
  <li><strong>Tags</strong>: แท็กสำหรับจัดกลุ่มลูกค้า</li>
</ul>

<h2>ฟิลด์แบบกำหนดเอง (Custom Fields)</h2>
<p>ระบบรองรับการเพิ่มฟิลด์แบบกำหนดเองตามความต้องการของแต่ละองค์กร:</p>
<ul>
  <li>สามารถเพิ่มฟิลด์ใหม่ได้ผ่าน Admin → Entity Configuration</li>
  <li>รองรับหลายประเภทข้อมูล (Text, Number, Date, Dropdown, etc.)</li>
  <li>สามารถใช้สูตร (Formula) สำหรับการคำนวณ</li>
</p>

<h2>การเชื่อมโยงข้อมูล (Relationships)</h2>
<p>ลูกค้าสามารถเชื่อมโยงกับข้อมูลอื่นๆ ได้:</p>
<ul>
  <li><strong>Leads</strong>: โอกาสในการขาย</li>
  <li><strong>Opportunities</strong>: โอกาสการขายที่กำลังดำเนินการ</li>
  <li><strong>Activities</strong>: กิจกรรมที่เกี่ยวข้อง</li>
  <li><strong>Notes</strong>: หมายเหตุ</li>
  <li><strong>Attachments</strong>: ไฟล์แนบ</li>
</ul>

<h2>คำแนะนำการใช้งาน</h2>

<h3>การสร้างลูกค้าใหม่</h3>
<ol>
  <li>เลือกประเภทลูกค้า (Customer Type)</li>
  <li>กรอกข้อมูลพื้นฐานที่จำเป็น</li>
  <li>เพิ่มข้อมูลเพิ่มเติมตามต้องการ</li>
  <li>คลิก "Save" เพื่อบันทึก</li>
</ol>

<h3>การอัปเดตข้อมูล</h3>
<ul>
  <li>สามารถแก้ไขข้อมูลได้ตลอดเวลา</li>
  <li>ระบบจะบันทึกประวัติการแก้ไข (Audit Trail)</li>
  <li>ข้อมูลที่เชื่อมโยงจะได้รับการอัปเดตตามความเหมาะสม</li>
</ul>

<h3>การค้นหาและกรอง</h3>
<ul>
  <li>ใช้ช่องค้นหาเพื่อหาลูกค้าจากชื่อ รหัส หรืออีเมล</li>
  <li>ใช้ตัวกรองเพื่อจำกัดผลการค้นหา</li>
  <li>สามารถจัดเรียงตามฟิลด์ต่างๆ ได้</li>
</ul>

<h2>การแก้ไขปัญหา</h2>

<h3>ไม่สามารถบันทึกได้</h3>
<ul>
  <li>ตรวจสอบว่ากรอกข้อมูลจำเป็นครบถ้วน (ตาม Customer Type)</li>
  <li>ตรวจสอบรูปแบบข้อมูล (เช่น อีเมล เบอร์โทร)</li>
  <li>ดูข้อความ error ที่แสดง</li>
</ul>

<h3>ข้อมูลไม่แสดง</h3>
<ul>
  <li>ตรวจสอบว่าฟิลด์ถูกตั้งค่าให้แสดงใน Entity Configuration</li>
  <li>ตรวจสอบสิทธิ์การเข้าถึงข้อมูล (Role Permissions)</li>
</ul>

<h2>เคล็ดลับ</h2>
<ul>
  <li>✅ ใช้ Customer Code เพื่อระบุตัวตนลูกค้าให้ชัดเจน</li>
  <li>✅ เพิ่ม Tags เพื่อจัดกลุ่มลูกค้าตามความต้องการ</li>
  <li>✅ เชื่อมโยงลูกค้ากับ Leads และ Opportunities เพื่อติดตามความคืบหน้า</li>
  <li>✅ ใช้ฟิลด์ Source เพื่อติดตามแหล่งที่มาของลูกค้า</li>
  <li>✅ อัปเดต Status ให้เป็นปัจจุบันเสมอ</li>
</ul>

<p><em><strong>อัปเดตล่าสุด</strong>: ธันวาคม 2025</em></p>
`;

